import { render, staticRenderFns } from "./listModel.vue?vue&type=template&id=3318d9de&"
import script from "./listModel.vue?vue&type=script&lang=js&"
export * from "./listModel.vue?vue&type=script&lang=js&"
import style0 from "./listModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports